'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginOverlay = require('./components/LoginOverlay.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LoginOverlay).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/login/lib/components/login-overlay/index.js
// module id = 1428
// module chunks = 1